<div class="container">
  @if (!this.rsvpDisplay) {
    <app-loading-spinner-overlay
      [isLoading]="true"
      [screenReaderText]="'Loading Pre-Registration information...'"
    ></app-loading-spinner-overlay>
  }
  <h1>
    @if (projectInfo?.ProjectName) {
      <span> Pre-Register to {{ projectInfo?.ProjectName }} </span>
    } @else {
      Enter Pre-Registration Information
    }
  </h1>
  <p class="description">
    @if (projectInfo?.ProjectDescription) {
      <span>
        {{ projectInfo?.ProjectDescription }}
      </span>
    }
  </p>

  <app-global-edit-stakeholder
    [projectInfo]="projectInfo"
    [stakeholderInfo]="stakeholderInfo"
    [isEdit]="isEdit"
    [goBackUrl]="'/rsvp/search'"
    (formResult)="handleStakeholderEditCreateResult($event)"
  ></app-global-edit-stakeholder>
</div>
